// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ids Virtual Scroll Component */
:host {
  display: flex;
  width: 100%;
  height: 100dvh;
}

:host([hidden]) {
  display: none;
}

.ids-virtual-scroll {
  display: grid;
  grid-auto-flow: column;
  width: 100%;
}
.ids-virtual-scroll:focus {
  outline: 0;
  justify-self: end;
}

.ids-virtual-scroll-content {
  position: relative;
}`, "",{"version":3,"sources":["webpack://./src/components/ids-virtual-scroll/ids-virtual-scroll.scss"],"names":[],"mappings":"AAAA,iCAAA;AAEA;EACE,aAAA;EACA,WAAA;EACA,cAAA;AAAF;;AAGA;EACE,aAAA;AAAF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;AAAF;AAEE;EACE,UAAA;EACA,iBAAA;AAAJ;;AAIA;EACE,kBAAA;AADF","sourcesContent":["/* Ids Virtual Scroll Component */\n\n:host {\n  display: flex;\n  width: 100%;\n  height: 100dvh;\n}\n\n:host([hidden]) {\n  display: none;\n}\n\n.ids-virtual-scroll {\n  display: grid;\n  grid-auto-flow: column;\n  width: 100%;\n\n  &:focus {\n    outline: 0;\n    justify-self: end;\n  }\n}\n\n.ids-virtual-scroll-content {\n  position: relative;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
